module.exports = __webpack_public_path__ + "05_mole.1a477785.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer2/05_mole.png
// module id = GYDW
// module chunks = 0